function Enhancement() {
  return {
    condition: function condition(Component) {
      var _Component$enhance;
      return Boolean((_Component$enhance = Component.enhance) === null || _Component$enhance === void 0 ? void 0 : _Component$enhance.length);
    },
    wrapperProps: function wrapperProps(props, WrapperComponent) {
      return WrapperComponent.enhance.reduce(function (acc, enhance) {
        return enhance(acc);
      }, props);
    }
  };
}
export default Enhancement;
//# sourceMappingURL=enhance.mjs.map